import { useSolutionConfiguration } from '../../../resources/solutionConfiguration/solutionConfigurationHandler';
import { useIsSourcingScenarioPcbOnlyType } from './useIsSourcingScenarioPcbOnlyType';

export const useIsSolutionConfigurationPcbOnlyType = (solutionConfigurationId: string) => {
    const { data: solutionConfiguration } = useSolutionConfiguration(solutionConfigurationId);
    return useIsSourcingScenarioPcbOnlyType(solutionConfiguration?.sourcing_scenario ?? '');
};
